var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBascet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    clipPath: "url(#clip0_55_588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.44128 10.6667H23.5599C23.9444 10.6667 24.3244 10.7498 24.6738 10.9103C25.0231 11.0709 25.3336 11.3051 25.584 11.5969C25.8344 11.8887 26.0187 12.2312 26.1243 12.6009C26.23 12.9706 26.2544 13.3587 26.1959 13.7387L24.5226 24.6081C24.3773 25.5527 23.8987 26.414 23.1733 27.0362C22.4479 27.6584 21.5236 28.0004 20.5679 28.0001H11.4319C10.4765 28 9.55258 27.658 8.82745 27.0358C8.10232 26.4136 7.62384 25.5524 7.47861 24.6081L5.80528 13.7387C5.74684 13.3587 5.77126 12.9706 5.87688 12.6009C5.98251 12.2312 6.16683 11.8887 6.4172 11.5969C6.66758 11.3051 6.9781 11.0709 7.32747 10.9103C7.67683 10.7498 8.05679 10.6667 8.44128 10.6667Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.6667V8C12 6.93913 12.4214 5.92172 13.1716 5.17157C13.9217 4.42143 14.9391 4 16 4C17.0609 4 18.0783 4.42143 18.8284 5.17157C19.5786 5.92172 20 6.93913 20 8V14.6667",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBascet);
export default __webpack_public_path__ + "static/media/bascet.d1b3793dfff16837523ecb4008a58ac0.svg";
export { ForwardRef as ReactComponent };